export enum Mode {
  Share,
  Export,
}
